import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface AnnouncementData {
  enabled: boolean;
  type: 'info' | 'warning' | 'error';
  dismissible: boolean;
  messages: Record<string, string>;
}

export function useAnnouncement() {
  return useQuery({
    queryKey: ['announcement'],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('site_settings')
        .select('value')
        .eq('key', 'announcement')
        .maybeSingle();

      if (error) throw error;
      if (!data) return null;
      return data.value as AnnouncementData;
    },
    staleTime: 60_000, // refresh every minute
  });
}
